import React, { useState } from 'react'
import { Breadcrumbs, InputField, SaveFixedButton, SelectInput } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'

export default function Edit({
  appProps, availableBranches, breadcrumbs, icon, organizationPath, region, updateRegionPath
}) {
  const [regionState, setRegionState] = useState(region)
  const [saveButtonRef, setSaveButtonRef] = useState(null)

  const handleInputChange = (field, value) => {
    saveButtonRef.setSaveableStatus()

    setRegionState(prevState => ({
      ...prevState,
      [field]: value
    }))
  }

  const handleRegionSave = () => {
    const { name, uid, branches } = regionState
    const fd = new FormData()

    fd.append('region[name]', name)
    fd.append('region[uid]', uid)
    fd.append('region_branch_ids', JSON.stringify(branches.map(el => el.value)))

    saveButtonRef.setSavingStatus()

    Rails.ajax({
      type: 'PATCH',
      url: updateRegionPath,
      dataType: 'json',
      data: fd,
      success: res => {
        saveButtonRef.setSuccessStatus()

        setRegionState(res.region)
      },
      error: res => saveButtonRef.setErrorStatusWithMessage(res.errors)
    })
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }` }/>
              <h1 className='page-header-title'>
                { region.uid }
              </h1>
            </div>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-body'>
            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.region.attributes.name }
              >
                <input
                  type='text'
                  value={ regionState.name }
                  onChange={ e => handleInputChange('name', e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.region.attributes.uid }
              >
                <input
                  type='text'
                  value={ regionState.uid }
                  onChange={ e => handleInputChange('uid', e.target.value) }
                />
              </InputField>
            </div>

            { availableBranches.length > 0
              ? <div>
                  <SelectInput
                    label={ Partners.translations.branch.plural }
                    options={ availableBranches }
                    currentOption={ regionState.branches.map(el => el.value) }
                    setCurrentOption={ option => handleInputChange('branches', option) }
                    multiple
                  />
                </div>
              : <div>
                  <a href={ organizationPath }>
                    { Partners.translations.region.no_available_branches }
                  </a>
                </div>
            }
          </div>
        </div>
      </div>

      <SaveFixedButton
        onSave={ handleRegionSave }
        entity={ Partners.translations.region.plural }
        ref={ ref => setSaveButtonRef(ref) }
      />
      <GlobalImports appProps={ appProps } />
    </>
  )
}